import type { ModelViewerPreviewResolution } from './previewResolution'

export const MODEL_VIEWER_RENDER_SUPERSAMPLING_FACTORS = [1, 2, 3, 4] as const

export type ModelViewerRenderSupersampling = (
    typeof MODEL_VIEWER_RENDER_SUPERSAMPLING_FACTORS[number]
)

export const DEFAULT_MODEL_VIEWER_RENDER_SUPERSAMPLING: ModelViewerRenderSupersampling = 1

// Keep supersampled buffers within a practical WebGL/SwiftShader envelope.
// The usual 1120×1000 preview and 1920×1080 both support the full 4× setting.
const MODEL_VIEWER_RENDER_MAX_INTERNAL_DIMENSION = 8192
const MODEL_VIEWER_RENDER_MAX_INTERNAL_PIXELS = 33_554_432

export const isModelViewerRenderSupersampling = (
    value: unknown,
): value is ModelViewerRenderSupersampling => (
    typeof value === 'number'
    && MODEL_VIEWER_RENDER_SUPERSAMPLING_FACTORS.includes(
        value as ModelViewerRenderSupersampling,
    )
)

export const isModelViewerRenderSupersamplingSupported = (
    resolution: ModelViewerPreviewResolution,
    supersampling: ModelViewerRenderSupersampling,
): boolean => {
    const internalWidth = resolution.width * supersampling
    const internalHeight = resolution.height * supersampling

    return internalWidth <= MODEL_VIEWER_RENDER_MAX_INTERNAL_DIMENSION
        && internalHeight <= MODEL_VIEWER_RENDER_MAX_INTERNAL_DIMENSION
        && internalWidth * internalHeight <= MODEL_VIEWER_RENDER_MAX_INTERNAL_PIXELS
}
